(() => {
  const loginModal = document.getElementById('loginModal');
  const loginSection = document.querySelector('.login-slidein__form');
  if (!loginModal || !loginSection) return;

  const form = loginModal.querySelector('.login-form');
  loginSection.insertAdjacentElement('afterbegin', form);
})();

(() => {
  const closeButtons = document.querySelectorAll('.account-slidein .js-close-slidein');
  if (!closeButtons.length) return;

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('.account-slidein').classList.remove('account-slidein--active');
    });
  });
})();

(() => {
  const openLogin = () => {
    document.querySelector('.login-slidein').classList.add('account-slidein--active');
  };

  document.querySelectorAll('*[data-target="#loginModal"]').forEach((button) => {
    button.dataset.target = '';
    button.addEventListener('click', openLogin);
  });
})();

(() => {
  const registerSlidenin = document.querySelector('.register-slidein');

  const openRegister = () => {
    registerSlidenin.classList.add('account-slidein--active');
  };

  document.querySelectorAll('.js-open-register').forEach((button) => {
    if (button.dataset.newcustomer === 'no') {
      button.addEventListener('click', () => {
        openRegister();
        registerSlidenin.querySelector('input[type="checkbox"]').checked = true;
      });
    } else {
      button.addEventListener('click', () => {
        openRegister();
        registerSlidenin.querySelector('input[type="checkbox"]').checked = false;
      });
    }
  });
})();
